import styled from 'styled-components';
import { Modal } from '@landr/maestro';

export const SectionWrapper = styled(Modal.Section)`
    padding: 0px;
    display: flex;
    ${({ theme }): string => theme.breakpoint('md')`
         flex-direction: column;
    `}
`;
